import { render, staticRenderFns } from "./modalFormulasAnteriores.vue?vue&type=template&id=84d132f2&"
import script from "./modalFormulasAnteriores.vue?vue&type=script&lang=js&"
export * from "./modalFormulasAnteriores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports